import { render } from "./SiteAvecJeu.vue?vue&type=template&id=1b263e1f&scoped=true"
import script from "./SiteAvecJeu.vue?vue&type=script&lang=js"
export * from "./SiteAvecJeu.vue?vue&type=script&lang=js"

import "./SiteAvecJeu.vue?vue&type=style&index=0&id=1b263e1f&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b263e1f"]])

export default __exports__